import memberSsoLoginTemplate from './member_sso_login.html';

function MemberSsoLoginDirective($rootScope, $sniffer, $window, $log, LoginService, QueryStringService, MemberOptions, bbConfig) {
    'ngInject';

    function link(scope) {
        const handleSso = () => {
            const options = {
                root: $rootScope.bb.api_url,
                company_id: QueryStringService('companyId') || scope.company_id || bbConfig.CORE.COMPANY_ID
            };

            const data = {
                token: scope.token ? scope.token : QueryStringService('sso_token')
            };

            if ($sniffer.msie && ($sniffer.msie < 10) && ($rootScope.iframe_proxy_ready === false)) {
                $timeout(() => {
                    loginSso(options, data);
                }, 2000);
            } else {
                loginSso(options, data);
            }
        };

        const redirectToErrorPage = (page) => {
            if (!page.includes('.html')) {
                $log.info('configured sso redirect page is not a valid html file');
            } else {
                $window.location.pathname = page;
            }
        };

        const loginSso = (options, data) => {
            LoginService.ssoLogin(options, data).then((member) => {
                scope.member = member;
            }, (err) => {
                $log.info('Could not complete member sso login', err);
                if (MemberOptions.ssoErrorRedirectPage) {
                    const redirectPath = bbConfig.BUILD.DEPLOY_PATH + MemberOptions.ssoErrorRedirectPage;
                    redirectToErrorPage(redirectPath);
                }
            });
        };

        handleSso();
    }

    return {
        scope: {
            token: '@memberSsoLogin',
            company_id: '@companyId'
        },
        transclude: true,
        templateUrl: memberSsoLoginTemplate.id,
        link
    };
}

/**
 * @ngdoc directive
 * @module BBMember
 * @name MemberSsoLoginDirective
 *
 * @description
 * Initialises member login with SSO
 */
angular
    .module('BBMember')
    .directive('memberSsoLogin', MemberSsoLoginDirective);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/member-sso-login/member_sso_login.directive.js